import sanitize from "sanitize-s3-objectkey";
import * as tus from "tus-js-client";

export const uploadFile = (
  apiUrl: string,
  file: File,
  directory?: string,
  apiAuth?: string,
  onProgress?: (progressPercentage: number) => void,
  onSuccess?: (fileName: string, fileUrl: string) => void,
  onError?: (error: Error) => void
) => {
  const splittedFile = file.name.split(".");
  const upload = new tus.Upload(file, {
    endpoint: apiUrl + "/upload/",
    retryDelays: [0, 3000, 5000, 10000, 20000],
    metadata: {
      filename: `${sanitize(splittedFile?.[0])}.${splittedFile?.[1]}`,
      filetype: file.type,
      directory: directory || "",
    },
    headers: {
      Authorization: `Bearer ${apiAuth}`,
    },
    chunkSize: 10 * 1024 * 1024,
    onError: function (error) {
      console.log("Failed because: " + error);
      onError && onError(error);
    },
    onProgress: function (bytesUploaded, bytesTotal) {
      const percentage = (bytesUploaded / bytesTotal) * 100;
      onProgress && onProgress(percentage);
    },
    onSuccess: function () {
      const finalPath = `${upload?.options?.metadata?.directory}/${upload?.options?.metadata?.filename}`;
      onSuccess && onSuccess(upload.file.name, finalPath);
    },
  });

  upload.findPreviousUploads().then(function (previousUploads) {
    if (previousUploads.length) {
      upload.resumeFromPreviousUpload(previousUploads[0]);
    }

    upload.start();
  });
};
